export default "__VITE_ASSET__zJtFSsnZ__ 1920w";